import { merge } from "lodash";
import React from "react";
import { DEFAULT_TABLE_STYLES } from "../table/v2/tableStyles";
import { ThemeContext } from "./useThemeContext";
import { colorShade } from "./colors";
import { TMS_THEME } from "./theming";
export var Client;
(function (Client) {
    Client["Portal"] = "portal";
    Client["TMS"] = "tms";
})(Client || (Client = {}));
export var ThemeProvider = function (_a) {
    var brandedTable = _a.brandedTable, children = _a.children, _b = _a.client, client = _b === void 0 ? Client.TMS : _b, buttonStyles = _a.buttonStyles;
    return (React.createElement(ThemeContext.Provider, { value: {
            brandedTable: getBrandedTableTheme(brandedTable),
            client: client,
            buttonStyles: getButtonStyles(buttonStyles),
        } }, children));
};
var getBrandedTableTheme = function (brandedTable) {
    if (brandedTable) {
        var brandedTheme = {
            header: {
                borderBottom: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                borderLeft: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                borderRight: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                borderTop: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                separator: {
                    width: 1,
                    color: adjustColourForBorder(brandedTable),
                },
                backgroundColor: brandedTable.backgroundColor,
                color: brandedTable.color,
            },
        };
        return merge({}, DEFAULT_TABLE_STYLES, brandedTheme);
    }
};
var adjustColourForBorder = function (brandedTable) {
    return "".concat(colorShade(brandedTable.backgroundColor, -50));
};
var getButtonStyles = function (buttonStyles) {
    var _a, _b, _c, _d, _e, _f, _g;
    var definedButtonsStyles = {
        primary: {
            color: TMS_THEME.palette.primary.base.contrast,
            backgroundColor: TMS_THEME.palette.primary.base.color,
            borderRadius: (_a = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _a === void 0 ? void 0 : _a.borderRadius,
        },
        default: {
            color: TMS_THEME.palette.primary.base.color,
            backgroundColor: "transparent",
            borderRadius: (_b = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _b === void 0 ? void 0 : _b.borderRadius,
        },
    };
    if (buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) {
        definedButtonsStyles = merge({}, definedButtonsStyles, {
            primary: {
                color: (_d = (_c = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _c === void 0 ? void 0 : _c.color) !== null && _d !== void 0 ? _d : TMS_THEME.palette.primary.base.contrast,
                backgroundColor: (_f = (_e = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _e === void 0 ? void 0 : _e.backgroundColor) !== null && _f !== void 0 ? _f : TMS_THEME.palette.primary.base.color,
            },
        });
    }
    if (buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.default) {
        definedButtonsStyles = merge({}, definedButtonsStyles, {
            default: { color: (_g = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.default) === null || _g === void 0 ? void 0 : _g.color },
        });
    }
    return definedButtonsStyles;
};
